// extracted by mini-css-extract-plugin
export default {"deliveryBanner":"_0aYKV0G1--DeliveryMapBanner_deliveryBanner__3hQof","icon":"_0aYKV0G1--DeliveryMapBanner_icon__OKSGE"};